<div class="btn-group {{ isInBaskets ? 'sq-document-in-baskets' : 'sq-document-not-in-baskets' }}"
    [sq-action-buttons]="{
        items: [basketsAction],
        autoAdjust: true,
        rightAligned: rightAligned
    }"></div>
